import { Menu } from "./components/Menu";
import { Scroll } from "./components/Scroll";
import { Theme } from "./components/Theme";
import { Newsletter } from "./components/Newsletter";

const main = {
  // Main process init
  init: function () {
    this.events();
  },

  intro: {
    body: document.querySelector('body'),
    loaderIsActif: false,
    start: function () {
    },
    stop: function () {
    }
  },

  // Components initialization
  components: function () {
    Menu.init();
    Theme.init();
    Scroll.init();
    Newsletter.init();
  },

  // Events handlers
  events: function () {

    document.addEventListener('readystatechange', function () {

      switch (document.readyState) {
        case 'loading':
          main.intro.start();
        case 'interactive':
        case 'loaded':
          break;

        case 'complete':
          main.components();

          if (!main.intro.loaderIsActif) {
            main.intro.stop();
          }
          break;

        default:
          break;
      }
    });
  }
}
export default main


// WEBPACK FOOTER //
// ./src/scripts/main.js